import React from 'react';
import PropTypes from 'prop-types';
import CampaignsListFilters from './CampaignsListFilters';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import AccountField from 'components/field/AccountField';
import authHelper from 'helpers/auth';
import listQueryFilter from 'components/hoc/listQueryFilter';
import { deleteCampaign } from 'store/actions/campaigns/deleteCampaigns';
import { fetchCampaigns } from 'store/actions/campaigns/fetchCampaigns';

const CampaignsList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    const isAdmin = authHelper.isAdmin();

    return (
        <div>
            <CampaignsListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchCampaigns }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table>
                    <TextField
                        { ...props }
                        column={ {
                            sortable: true,
                            width: '30%',
                        } }
                        source='name'
                        label='resources.campaigns.fields.name'
                    />

                    <TextField
                        { ...props }
                        column={ {
                            sortable: false,
                            width: '10%',
                        } }
                        source='id'
                        label='resources.campaigns.fields.id'
                    />

                    <TextField
                        { ...props }
                        column={ {
                            sortable: false,
                            width: '30%',
                        } }
                        source='identifier'
                        label='resources.campaigns.fields.identifier'
                    />

                    { isAdmin &&
                        <AccountField
                            column={ {
                                link: false,
                                sortable: false,
                            } }
                            display='name'
                            label='resources.campaigns.fields.accountId'
                            source='account_id'
                        />
                    }

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        source='actions'
                    >
                        <EditAction />

                        <DeleteAction action={ deleteCampaign } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

CampaignsList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(CampaignsList);



// WEBPACK FOOTER //
// ./src/pages/campaigns/list/CampaignsList.js